// extracted by mini-css-extract-plugin
export default {"BaseCell":"date-renderer-module__BaseCell--u8IFW"};